<app-modal-dialog [show]="showModal" (closed)="close(modal)" size="lg" position="top" #modal>
  <div class="modal-header" modal-header>
    <div class="d-flex align-items-center justify-content-between w-100">
      <h3 class="m-0">Detalle de Reservación</h3>
      <i class="fa fa-xmark i-hover" (click)="close(modal)"></i>
    </div>
  </div>

  <div class="modal-body" modal-body>
    <div *ngIf="reservationDetail" class="mb-3">
      <div class="row mb-2">
        <div class="col-md-4">
          <strong>Número:</strong> {{ reservationDetail.number }}
        </div>
        <div class="col-md-4">
          <strong>Bodega:</strong> {{ reservationDetail.warehouseData?.name || ('N/A')}}
        </div>
        <div class="col-md-4">
          <strong>Cliente:</strong> {{ reservationDetail.clientName }}
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-md-4">
          <strong>Fecha Reserva:</strong>
          {{ reservationDetail.reservedDate | date:'yyyy/MM/dd HH:mm:ss' }}
        </div>
        <div class="col-md-4">
          <strong>Fecha Expiración:</strong>
          {{ reservationDetail.expirationDate | date:'yyyy/MM/dd HH:mm:ss' }}
        </div>
        <div class="col-md-4">
          <strong>Estado:</strong>
          <span class="badge px-3" [ngClass]="getStatusColor(reservationDetail.status)">
            {{ reservationDetail.status }}
          </span>
        </div>
      </div>
    </div>

    <hr />

    <h6 class="text-muted mb-2">
      <i class="fa fa-boxes-stacked me-1"></i> Productos Reservados
    </h6>

    <div *ngIf="detailLoading" class="text-center my-3">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Cargando...</span>
      </div>
    </div>

    <div class="table-responsive" *ngIf="!detailLoading && reservationDetails.length > 0">
      <table class="table table-striped table-sm align-middle">
        <thead class="table-light">
          <tr>
            <th>#</th>
            <th>Producto</th>
            <th class="ta">Cantidad</th>
            <!-- <th class="ta">Precio</th> -->
            <!-- <th class="ta">Subtotal</th> -->
          </tr>
        </thead>

        <tbody>
          <ng-container *ngFor="let item of reservationDetails; let i = index">
            <tr>
              <td>{{ i + 1 }}</td>
              <td class="d-flex flex-row align-content-start">
                <div class="d-flex flex-column">
                  <span>{{ item.productData?.name || '-' }}</span>
                  <span class="text-muted" style="font-size: 0.80rem;">{{item.comment}}</span>
                </div>
                <button
                  class="btn btn-sm btn-link text-primary"
                  (click)="toggleBreakdown(item)"
                  *ngIf="reservationDetail.status==statuses.RESERVED"
                >
                  <i
                    class="fa"
                    [ngClass]="{
                      'fa-chevron-down': !item.showBreakdown,
                      'fa-chevron-up': item.showBreakdown
                    }"
                  ></i>
                  Seleccionar Traslado
                </button>
              </td>
              <!-- <td class="ta">{{ item.warehouseData?.name || '-' }}</td> -->
              <td class="ta">{{ item.quantity }}</td>
              <!-- <td class="ta">{{ item.price | currency:'Q ' }}</td> -->
              <!-- <td class="ta">{{ (item.quantity * item.price) | currency:'Q ' }}</td> -->
            </tr>

            <tr *ngIf="item.showBreakdown">
              <td colspan="6">
                <div *ngIf="!item.warehouseExistence">
                  <div class="text-center my-2">
                    <div class="spinner-border text-primary" role="status"></div>
                  </div>
                </div>

                <div *ngIf="item.warehouseExistence">
                  <table class="table table-bordered table-sm">
                    <thead class="table-light">
                      <tr>
                        <th>Bodega</th>
                        <th class="ta">Existencia</th>
                        <th class="ta">Cantidad a pasar</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let w of item.warehouseExistence">
                        <td>{{ w.warehouseName }}</td>
                        <td class="ta">{{ w.existence }}</td>
                        <td class="ta">
                          <input
                            type="number"
                            class="form-control form-control-sm text-end"
                            [(ngModel)]="w.transferQuantity"
                            [max]="w.existence"
                            min="0"
                            (input)="validateTransferQuantity(item, w)"
                          />
                        </td>
                      </tr>
                    </tbody>
                    <tfoot class="fw-bold bg-light">
                      <tr>
                        <td colspan="2" class="text-end">Total a enviar:</td>
                        <td class="ta">{{ getTotalTransferQuantity(item) }}</td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>

        <!-- <tfoot class="fw-bold">
          <tr>
            <td colspan="5" class="text-end">Total</td>
            <td class="text-end">{{ getReservationTotal() | currency:'Q ' }}</td>
          </tr>
        </tfoot> -->
      </table>
    </div>

    <div
      *ngIf="!detailLoading && reservationDetails.length === 0"
      class="text-muted text-center py-3"
    >
      <i class="fa fa-circle-info"></i> No hay productos en esta reservación
    </div>
    <div
      class="text-end mt-3"
      *ngIf="
        !detailLoading &&
        reservationDetails.length > 0 &&
        reservationDetail.status==statuses.RESERVED
      "
    >
      <button class="btn btn-success px-4" (click)="confirmTransfer()">
        Despachar
      </button>
    </div>
  </div>
</app-modal-dialog>
